import * as React from "react";
import { forwardRef } from "react";
const SvgLeftMenu = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 10, height: 14, fill: "none", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#fff", d: "M7.823 0c.348.002.693.076 1.01.217.344.148.637.39.843.696.207.307.32.665.324 1.032v9.151a1.9 1.9 0 0 1-.324 1.032c-.206.306-.499.548-.843.696a2.38 2.38 0 0 1-2.455-.282L.712 7.966a1.86 1.86 0 0 1-.525-.643 1.82 1.82 0 0 1 0-1.605c.124-.25.303-.47.525-.643L6.378.5A2.32 2.32 0 0 1 7.823 0" }));
const ForwardRef = forwardRef(SvgLeftMenu);
export { ForwardRef as ReactComponent };
